export const SESSION_STORAGE_KEYS = {
  edenredOneToPage: 'one-to-page',
} as const;

export type SessionStorageKey =
  (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS];
